import { render, staticRenderFns } from "./gallery-desc.vue?vue&type=template&id=0f49fbcc"
import script from "./gallery-desc.vue?vue&type=script&lang=js"
export * from "./gallery-desc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports